import { render, staticRenderFns } from "./PacienteFichaOrcamentoTabela.vue?vue&type=template&id=123fbd02&scoped=true"
import script from "./PacienteFichaOrcamentoTabela.vue?vue&type=script&lang=js"
export * from "./PacienteFichaOrcamentoTabela.vue?vue&type=script&lang=js"
import style0 from "./PacienteFichaOrcamentoTabela.vue?vue&type=style&index=0&id=123fbd02&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123fbd02",
  null
  
)

export default component.exports